<template>
  <div class="user-wrapper wrapper_1200">
    <div class="router-tips">
      <router-link to="/">{{ $t(`page.store.index`) }}></router-link>
      <router-link :to="{ path: '/users' }">{{
        $t(`page.users.userInfo.personalCenter`)
      }}</router-link>
    </div>
    <div class="content acea-row">
      <div class="left-box">
        <div class="left-box">
          <div class="user-menu">
            <div
              @click="goPage(menu, index)"
              class="menu-item"
              v-for="(menu, index) in userMenu"
              :key="menu.id"
              :class="{ active: menuCur == menu.id }"
            >
              <!-- {{$t(`page.user.mineNav[${index}].name`)}} -->
              <span v-show="menu.pc_url && menu.pc_url != ' '">{{
                menu.name
              }}</span>
            </div>
            <el-divider></el-divider>
            <div
              @click="goPage(menu, index)"
              class="menu-item"
              v-for="(menu, index) in menus"
              :key="menu.id"
              :class="{ active: menuCur == menu.id }"
            >
              <span v-show="menu.pc_url && menu.pc_url != ' '">{{
                menu.name
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="right-box">
        <component :is="currentComponent" v-if="currentComponent" />
      </div>
    </div>
    <FloatWindow></FloatWindow>
  </div>
</template>
<script>
// 导入 users 文件夹下的子页面组件
import OrderList from "./users/order_list.vue";
import Wallet from "./users/wallet.vue";
import InvoiceList from "./users/invoice_list.vue";
import UserInfo from "./users/user_info.vue";
import AddressList from "./users/address_list.vue";
import CollectionList from "./users/collection_list.vue";
import ApplicationRecord from "./users/application_record.vue";
import RefundList from "./users/refund_list.vue";
import EvaluationList from "./users/evaluation_list.vue";
import CouponList from "./users/coupon_list.vue";
import AfterSale from "./users/after_sale.vue";
import RefundConfirm from "./users/refund_confirm.vue";
import EvaluationConfirm from "./users/evaluation_confirm.vue";
export default {
  name: "user",
  auth: "guest",
  components: {
    OrderList,
    Wallet,
    InvoiceList,
    UserInfo,
    AddressList,
    CollectionList,
    ApplicationRecord,
    RefundList,
    EvaluationList,
    CouponList,
    AfterSale,
    RefundConfirm,
    EvaluationConfirm
  },
  computed: {
    currentComponent() {
      const path = this.$route.path;
      const componentMap = {
        "/users/order_list": "OrderList",
        "/users/wallet": "Wallet",
        "/users/invoice_list": "InvoiceList",
        "/users/user_info": "UserInfo",
        "/users/address_list": "AddressList",
        "/users/collection_list": "CollectionList",
        "/users/application_record": "ApplicationRecord",
        "/users/refund_list": "RefundList",
        "/users/evaluation_list": "EvaluationList",
        "/users/coupon_list": "CouponList",
        "/users/after_sale": "AfterSale",
        "/users/refund_confirm": "RefundConfirm",
        "/users/evaluation_confirm": "EvaluationConfirm"
      };
      return componentMap[path] || null;
    },
    userMenu() {
      return [
        {
          id: 111,
          name: this.$t(`page.user.myOrder`),
          pc_url: "/users/order_list",
        },
        {
          id: 222,
          name: this.$t(`page.users.afterSale.navTitle`),
          pc_url: '/users/after_sale'
        },
        {
          id: 333,
          name: this.$t(`page.users.replyList.navTitle`),
          pc_url: '/users/evaluation_list'
        },
        {
          id: 444,
          name: this.$t(`page.users.wallet.navTitle`),
          pc_url: "/users/wallet",
        },
        {
          id: 555,
          name: this.$t(`page.users.invoiceList.navTitle`),
          pc_url: "/users/invoice_list",
        },
      ];
    },
    menus() {
      return [
        {
          name: this.$t(`page.user.profile`),
          id: 709,
          pc_url: "/users/user_info",
          url: "/pages/users/user_info/index",
        },
        {
          name: this.$t(`page.user.address`),
          id: 710,
          pc_url: "/users/address_list",
          url: "/pages/users/user_address_list/index",
        },
        {
          name: this.$t(`page.user.like`),
          id: 711,
          pc_url: "/users/collection_list",
          url: "/pages/users/user_goods_collection/index",
        },
        // {
        //   name: this.$t(`page.user.service`),
        //   id: 715,
        //   pc_url: "/users/application_record",
        //   url: "/pages/merchant/application_record/index",
        // },
      ];
    },
  },
  data() {
    return {
      userInfo: {},
      indexCur: 111,
      menuCur: undefined,
    };
  },

  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.updateMenuCur();
      },
      // 深度观察监听
      deep: true,
    },
  },
  head() {
    return {
      title: "",
    };
  },
  mounted() {
    this.updateMenuCur();
  },
  methods: {
    updateMenuCur() {
      const path = this.$route.path;
      // 检查 userMenu
      const userMenuItem = this.userMenu.find(item => item.pc_url === path);
      if (userMenuItem) {
        this.menuCur = userMenuItem.id;
        return;
      }
      // 检查 menus
      if (this.menus) {
        const menuItem = this.menus.find(item => item.pc_url === path);
        if (menuItem) {
          this.menuCur = menuItem.id;
          return;
        }
      }
      // 如果没有匹配到，默认保持当前或者设置默认值
      if (!this.menuCur) {
        this.menuCur = 111;
      }
    },
    goPage(menu, index) {
      this.menuCur = menu.id;
      this.$router.push({
        path: `${menu.pc_url}`,
        query: { menuCur: menu.id },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.user-wrapper {
  .left-box {
    width: 210px;
    .user-info {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 170px;
      background: #fff;
      color: #282828;
      font-size: 14px;
      .name {
        margin-top: 10px;
        padding: 0 15px;
      }
    }
    .user-menu {
      padding: 30px 0;
      background: #fff;
      ::v-deep.el-divider--horizontal {
        margin: 35px 0 !important;
      }
      .menu-item {
        display: block;
        margin-bottom: 38px;
        color: #333333;
        cursor: pointer;
        font-size: 14px;
        padding-left: 20px;
        &.active {
          color: #e93323;
          background: url("~@/assets/images/left-icon.png") no-repeat left
            center;
        }
      }
    }
  }
  .right-box {
    width: 975px;
    min-height: 730px;
    margin-left: 15px;
    padding-bottom: 30px;
  }
}

.router-tips {
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #333;
  a {
    color: #333;
  }
  span {
    color: #999999;
  }
}
</style>
